module.exports = __webpack_public_path__ + "img/paslaugos_img.jpg.eab023e.webp";